var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_vm._v(" dawdawdawd ")])
}
var staticRenderFns = []

export { render, staticRenderFns }